export const NEW_ARRIVALS_PAGE_SIZE = 12
export const NEW_ARRIVALS_MAX_TOTAL = 49

export type NewArrivalProduct = {
  id?: string
  sku?: string | null
  name: string
  imageUrl: string | null
  imageAlt?: string
  partNumber?: string | null
}

export function getNewArrivalsEffectiveTotal(catalogTotal: number): number {
  return Math.min(catalogTotal, NEW_ARRIVALS_MAX_TOTAL)
}
